import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getConfigObject } from "../../../utils/utils";
import { ProviderGroupControllerApi } from "../../../services";
import { ProviderGroupDetails } from "../../../types/provider-types";

/**
 *
 * @author rajkumar rathod
 */
export const useGetProviderGroupProfile = (
  schemaName?: string,
  disabled?: boolean
): UseQueryResult<ProviderGroupDetails | undefined, AxiosError> =>
  useQuery({
    queryKey: ["provider-group-profile-key", schemaName, disabled],
    enabled: !!schemaName && !disabled,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ProviderGroupControllerApi(getConfigObject())
        .getProviderGroupProfile(schemaName!)
        // The generated client types every envelope's `data` as `object`.
        .then((res) => res?.data?.data as ProviderGroupDetails),
  });
